// TODO: reimplement datetime utils with dayjs

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

export const stringToDate = (s: string): Date => dayjs(s).toDate();

export const addMinutes = (minutes: number, date: Date = new Date()) => {
  const newDate = new Date(date.getTime() + minutes * 60_000);

  return newDate;
};

// convert Date object to timestamp
export const convertDateToTimestamp = (date: Date): number => Date.parse(date.toISOString());

// calculate difference of 2 timestamps in milliseconds
export const diffTimestamps = (ts1: number, ts2: number): number => Math.abs(ts1 - ts2);

// calculate difference of 2 dates in milliseconds
export const diffTimes = (
  startDate: Date | string | number = new Date(),
  endDate: Date | string | number = new Date()
): number => dayjs(startDate).diff(dayjs(endDate));

// To get the difference in milliseconds
export const getDuration = (startDate: Date | string | number = new Date()) => Math.abs(dayjs(startDate).diff(dayjs()));

export const getCountdownDuration = (endDate: string) => {
  const diff = dayjs(Date.parse(endDate)).diff(dayjs(new Date()));

  return diff > 0 ? diff : 0;
};

// Format duration
export const displayDuration = (milliseconds: number) => {
  let validFormat = 'mm:ss';

  if (dayjs.duration(milliseconds).hours()) {
    validFormat = 'HH:mm:ss';
  }

  return dayjs.duration(milliseconds).format(validFormat);
};

export const formatDurationToMinutes = (minutes: number) => {
  const milliseconds = minutes * 60 * 1_000;
  let validFormat = 'm[min]';
  const hours = dayjs.duration(milliseconds).hours();

  if (minutes === 0) {
    return '1 min';
  }

  if (hours) {
    validFormat = 'H[h] m[m]';
  }

  return dayjs.duration(milliseconds).format(validFormat);
};

export const displayInTwoDigitFormat = (n: number): string =>
  n.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

export const displayDate = (date: string) => dayjs(date).format('D MMM');

export const displayTimeAgo = (date: string) => {
  dayjs.extend(relativeTime);
  dayjs.extend(updateLocale);

  dayjs.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      m: 'a min',
      mm: '%d min',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    }
  });

  const dayDifference = dayjs.duration(Math.abs(diffTimes(date))).days();

  if (dayDifference > 7) {
    return displayDate(date);
  }

  return dayjs(date).fromNow();
};

export const displayDateTime = (date: string) => dayjs(date).format('DD MMM hh:mm A');

export const displayRemainingPlanTime = (minutes: number) => {
  const hoursLeft = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;

  if (hoursLeft > 1) {
    return `${hoursLeft} hours`;
  }

  if (hoursLeft === 1) {
    return '1 hour';
  }

  if (minutesLeft === 1) {
    return '1 minute';
  }

  if (minutesLeft > 0) {
    return `${minutesLeft} minutes`;
  }

  return '0 minutes';
};

export const convertMinutesToHours = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return getPlural(minutes, 'minute');
  }

  return `${getPlural(hours, 'hour')} ${getPlural(minutes, 'minute')}`;
};

const getPlural = (amount: number, string: string) => {
  if (amount === 1) {
    return `${amount} ${string}`;
  }

  return `${amount} ${string}s`;
};
